import { Plugin } from '@nuxt/types'
import LogRocket from 'logrocket'

const logrocketPlugin: Plugin = ({ $config }) => {
  if ($config.LOGROCKET_IS_ENABLED && $config.LOGROCKET_APP_ID) {
    LogRocket.init($config.LOGROCKET_APP_ID, {
      dom: {
        inputSanitizer: 'lipsum',
      },
    })
  }
}

export default logrocketPlugin
